/* eslint-disable max-len */
/**
 * Awvent - Awvent Users API
 * Awvent User Apis
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */
// Third party library imports
import { HttpClient, HttpEvent, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';

// Zopup library imports
import { BooleanWebApiResponse, UserCreateCommand, UserDisableCommand, UserDtoListWebApiPagedResponse, UserDtoWebApiResponse, UserEmailInvitationCommand, UserEnableCommand, UserUpdateCommand } from '@zopup/zop-types';

// Internal project imports
import { USERS_API_BASE_PATH } from '../api-tokens';
import { BaseService } from '../api.base.service';
import { CustomHttpUrlEncodingCodec } from '../encoder';


@Injectable({providedIn: 'root'})
export class UserService extends BaseService {

    constructor(
        protected httpClient: HttpClient,
        @Inject(USERS_API_BASE_PATH) private apiBasePath: string
    ) {
        super();
        this.basePath = this.apiBasePath;
        this.configuration.basePath = this.basePath;
    }

    /**
     *
     *
     * @param uId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userCheckEmailVerificationGet(uId?: string, observe?: 'body', reportProgress?: boolean): Observable<BooleanWebApiResponse>;
    public userCheckEmailVerificationGet(uId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BooleanWebApiResponse>>;
    public userCheckEmailVerificationGet(uId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BooleanWebApiResponse>>;
    public userCheckEmailVerificationGet(uId?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (uId !== undefined && uId !== null) {
            queryParameters = queryParameters.set('UId', uId as any);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BooleanWebApiResponse>('get', `${this.basePath}/User/CheckEmailVerification`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userDisablePut(body?: UserDisableCommand, observe?: 'body', reportProgress?: boolean): Observable<UserDtoWebApiResponse>;
    public userDisablePut(body?: UserDisableCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDtoWebApiResponse>>;
    public userDisablePut(body?: UserDisableCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDtoWebApiResponse>>;
    public userDisablePut(body?: UserDisableCommand, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserDtoWebApiResponse>('put', `${this.basePath}/User/Disable`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userEnablePut(body?: UserEnableCommand, observe?: 'body', reportProgress?: boolean): Observable<UserDtoWebApiResponse>;
    public userEnablePut(body?: UserEnableCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDtoWebApiResponse>>;
    public userEnablePut(body?: UserEnableCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDtoWebApiResponse>>;
    public userEnablePut(body?: UserEnableCommand, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserDtoWebApiResponse>('put', `${this.basePath}/User/Enable`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param email
     * @param phoneNumber
     * @param mobileNumber
     * @param isActive
     * @param orderBy
     * @param isOrderByDescending
     * @param searchText
     * @param pageNumber
     * @param pageSize
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGet(email?: string, phoneNumber?: string, mobileNumber?: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<UserDtoListWebApiPagedResponse>;
    public userGet(email?: string, phoneNumber?: string, mobileNumber?: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDtoListWebApiPagedResponse>>;
    public userGet(email?: string, phoneNumber?: string, mobileNumber?: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDtoListWebApiPagedResponse>>;
    public userGet(email?: string, phoneNumber?: string, mobileNumber?: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('Email', email as any);
        }
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('PhoneNumber', phoneNumber as any);
        }
        if (mobileNumber !== undefined && mobileNumber !== null) {
            queryParameters = queryParameters.set('MobileNumber', mobileNumber as any);
        }
        if (isActive !== undefined && isActive !== null) {
            queryParameters = queryParameters.set('IsActive', isActive as any);
        }
        if (orderBy) {
            orderBy.forEach((element) => {
                queryParameters = queryParameters.append('OrderBy', element as any);
            });
        }
        if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
            queryParameters = queryParameters.set('IsOrderByDescending', isOrderByDescending as any);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', searchText as any);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', pageNumber as any);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', pageSize as any);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UserDtoListWebApiPagedResponse>('get', `${this.basePath}/User`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPost(body?: UserCreateCommand, observe?: 'body', reportProgress?: boolean): Observable<UserDtoWebApiResponse>;
    public userPost(body?: UserCreateCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDtoWebApiResponse>>;
    public userPost(body?: UserCreateCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDtoWebApiResponse>>;
    public userPost(body?: UserCreateCommand, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;
        headers = headers.set('x-request-id', Guid.create().toString());

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserDtoWebApiResponse>('post', `${this.basePath}/User`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPut(body?: UserUpdateCommand, observe?: 'body', reportProgress?: boolean): Observable<UserDtoWebApiResponse>;
    public userPut(body?: UserUpdateCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDtoWebApiResponse>>;
    public userPut(body?: UserUpdateCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDtoWebApiResponse>>;
    public userPut(body?: UserUpdateCommand, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserDtoWebApiResponse>('put', `${this.basePath}/User`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userSendEmailInvitationPut(body?: UserEmailInvitationCommand, observe?: 'body', reportProgress?: boolean): Observable<BooleanWebApiResponse>;
    public userSendEmailInvitationPut(body?: UserEmailInvitationCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BooleanWebApiResponse>>;
    public userSendEmailInvitationPut(body?: UserEmailInvitationCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BooleanWebApiResponse>>;
    public userSendEmailInvitationPut(body?: UserEmailInvitationCommand, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<BooleanWebApiResponse>('put', `${this.basePath}/User/SendEmailInvitation`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param uId
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userSingleGet(uId?: string, id?: string, observe?: 'body', reportProgress?: boolean): Observable<UserDtoWebApiResponse>;
    public userSingleGet(uId?: string, id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDtoWebApiResponse>>;
    public userSingleGet(uId?: string, id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDtoWebApiResponse>>;
    public userSingleGet(uId?: string, id?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (uId !== undefined && uId !== null) {
            queryParameters = queryParameters.set('UId', uId as any);
        }
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('Id', id as any);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UserDtoWebApiResponse>('get', `${this.basePath}/User/Single`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
